// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__14cex","header":"ReportDetails_header__2JU-l","title":"ReportDetails_title__2XKum","left":"ReportDetails_left__19BZJ"};